module.exports = __webpack_public_path__ + "img/dsci0094.e2684123.jpg";